jQuery(document).on('ready', function () {
    
    // Check if component is added to the page
    if( jQuery('section.section').length ) {
        //wrap content into sections based on .section-start elements
        if (jQuery('.components.first-section-dark').length) {
            $color = "section-dark";
        } else {
            $color = "section-light";
        }
        jQuery("section.section").each(function() {
            jQuery(this).nextUntil('.section').appendTo(jQuery(this));
            jQuery(this).addClass($color);
            if( !jQuery('section.estimates').length && (jQuery(this).prev().filter('section.section').length || jQuery(this).prev().not('section.section').length) ) {
                if( !jQuery(this).find('.jump-next-section').length ) {
                    jQuery(this).prepend('<div class="jump-next-section"></div>');
                }
            }
            if ($color=="section-light") {
                $color = "section-dark";
            } else {
                $color = "section-light";
            }
        });
        if( jQuery('.jump-next-section').length ) {
            jQuery('.title-slider').addClass('has-jump-next-section-arrow');
        }
    }

    // Jump to next section
    jQuery("section").on('click', '.jump-next-section:not(.special)', function() {
        scrollToElement(false, jQuery(this).parents('section').offset().top);
    });

});